// extracted by mini-css-extract-plugin
export const titleContainer = "about-module--titleContainer--C6Mgh";
export const title = "about-module--title--2xFcy";
export const sections = "about-module--sections--2hSOR";
export const dark = "about-module--dark--36qQ1";
export const details = "about-module--details--1UJkw";
export const detailTitle = "about-module--detailTitle--1G_Lr";
export const detailText = "about-module--detailText--3ECgF";